import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Sweetalert2Service } from '../../../core/services/sweetalert2.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalSalesPersonComponent } from '../modal-sales-person/modal-sales-person.component';
import { ModalTeamTransferComponent } from '../modal-team-transfer/modal-team-transfer.component';
import { SalesStructureService } from '../../../core/services/sales-structure.service';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit, OnChanges {

  @Input() data = [];
  @Input() config = {};
  @Input() mode = '';
  @Input() teamId;
  @Input() companyId;
  @Input() branchId  = '';
  @Input() action = '';
  @Input() team: any = {};
  @Input() salesStructureId;

  @Output() onHandler = new EventEmitter();
  @Output() onTransfer = new EventEmitter();
  @Output() onReload = new EventEmitter();

  tree = [];

  constructor(private _sweetlert2Service: Sweetalert2Service,
              private _dialog: MatDialog,
              private _salesStructureService: SalesStructureService) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateTree();
  }

  normalized(data) {
    return new Promise((resolve, reject) => {
      const list = [];
      const root = data.filter(i => i.levelSequence === 1)[0];

      if (this.mode === 'add') {
        if (root) {
          // root node
          list.push({
            id: root.parentLevelCode,
            code: root.parentLevelCode,
            parentId: null,
            children: null,
            expand: true,
            sales: null,
            level: 0,
          });

          // children node
          data.forEach(value => {
            list.push({
              id: value.childLevelCode,
              code: value.childLevelCode,
              parentId: value.parentLevelCode,
              children: null,
              expand: true,
              sales: null,
              level: value.levelSequence
            });
          });
        }
      } else {
        if (root) {
          // root node
          list.push({
            id: root.parentLevelCode,
            code: root.parentLevelCode,
            parentId: null,
            children: null,
            expand: true,
            sales: null,
            level: 0,
          });

          // children node
          data.forEach(value => {
            list.push({
              id: value.salespersonId,
              code: value.levelCode,
              parentId: (value.supervisorId) ? value.supervisorId : root.parentLevelCode,
              children: null,
              expand: true,
              sales: {
                firstName: value.firstName,
                lastName: value.lastName,
                citizenId: value.salespersonCitizenId
              },
              level: value.levelSequence,
            });
          });
        }
      }

      return resolve(list);
    });
  }

  async generateTree(): Promise<void> {
    const list = await this.normalized(this.data).then(i => i);
    const tree = await this.listToTree(list, {
      idKey: 'id',
      parentKey: 'parentId',
      childrenKey: 'children'
    }).then(i => i);

    if (tree && tree.length) {
      this.tree = tree;

      if (this.action !== 'transfer') {
        this.onTreeChange();
      }
    }
  }

  onAddTeam(item, parent): void {
    this._sweetlert2Service.withConfirm('ยืนยัน', `คุณต้องการ${item.code !== 'DS' ? `สร้างสายงาน ${item.code}` : `เพิ่มพนักงานขาย`}ใช่หรือไม่ ?`)
      .then(async confirm => {
        if (confirm) {
          if (item.code !== 'DS') {
            this._salesStructureService.getSalesStructure(this.companyId, this.salesStructureId)
              .toPromise()
              .then(async res => {
                if (res && res.model) {
                  const data = res.model.salesStructureDetails.filter(i => i.levelSequence >= item.level);
                  const list = [];
                  const isChildren = item.children.length > 0;

                  data.forEach(value => {
                    list.push({
                      id: value.childLevelCode,
                      code: value.childLevelCode,
                      parentId: (value.levelSequence === item.level) ? null : value.parentLevelCode,
                      children: null,
                      expand: true,
                      sales: null,
                      parent: {
                        code: parent.code,
                        sales: parent.sales
                      },
                      level: value.levelSequence
                    });
                  });

                  if (list.length > 0) {
                    const tree = await this.listToTree(list, {
                      idKey: 'id',
                      parentKey: 'parentId',
                      childrenKey: 'children',
                    }).then(i => i);

                    if (tree.length) {
                      let _tree;

                      // if (this.mode === 'add') {
                      //   _tree = tree[0];
                      // } else {
                      //   _tree = tree.filter(i => i.id === item.id)[0];
                      // }
                      _tree = tree[0];

                      if (_tree) {
                        _tree.parentId = parent.id;

                        if (isChildren) {
                          parent.children.push(_tree);
                        } else {
                          item.children.push(_tree.children[0]);
                        }

                        this.onTreeChange();
                      }
                    }
                  }
                }
              });
          } else {
            parent.children.push({
              id: 'DS',
              code: 'DS',
              parentId: parent.id,
              children: [],
              expand: true,
              sales: null,
              parent: {
                code: parent.code,
                sales: parent.sales
              },
              level: item.level
            });

            this.onTreeChange();
          }
        }
      });
  }

  onEditSales(item, parent): void {
    const dialogRef = this._dialog.open(ModalSalesPersonComponent, {
      width: '800px',
      data: {
        companyId: this.companyId,
        branchId: this.branchId
      }
    });

    dialogRef.afterClosed().subscribe(sales => {
      if (sales) {
        item.sales = sales;
        item.children.forEach(value => {
          value.parent = {
            code: item.code,
            sales: sales
          };
        });

        this.onTreeChange();
      }
    });
  }

  onTransferTeam(item, parent): void {
    const dialogRef = this._dialog.open(ModalTeamTransferComponent, {
      width: '800px',
      data: {
        team: Object.assign({}, item)
      }
    });

    dialogRef.afterClosed().subscribe(team => {
      if (team) {
        this.onReload.emit(true);
        // const index = parent.children.indexOf(item);
        //
        // if (index > -1) {
        //   parent.children.splice(index, 1);
        //
        //   this.onTreeChange(true);
        // }
      }
    });
  }

  onDeleteTeam(item, parent): void {
    this._sweetlert2Service.withConfirm('ยืนยัน', `คุณต้องการ${item.code !== 'DS' ? `ลบสายงาน ${item.code}` : `ลบพนักงานขาย`}ใช่หรือไม่ ?`)
      .then(confirm => {
        if (confirm) {
          const index = parent.children.indexOf(item);

          parent.children.splice(index, 1);

          this.onTreeChange();
        }
      });
  }

  treeToList(data): Promise<any> {
   return new Promise((resolve, reject) => {
      try {
        const extract = x => x.children;
        const flat = this.flatten(extract(data), extract, null);

        return resolve(flat);
      } catch (e) {
        return reject(e);
      }
    });
  }

  flatten(children, extractChildren, level): any {
    return Array.prototype.concat.apply(
      children.map(x => ({ ...x, level: level || 1, parent: x.parent || null })),
      children.map(x => this.flatten(extractChildren(x) || [], extractChildren, (level || 1) + 1))
    );
  }

  onTreeChange(transfer = false): void {
    let root = this.data.filter(i => i.levelSequence === 1)[0];

    if (this.mode === 'add') {
      root = root.parentLevelCode;
    } else {
      root = root.parentLevelCode;
    }

    this.treeToList(this.tree[0])
      .then(item => {
        const data = [];

        item.forEach(value => {
          data.push({
            levelCode: value.code,
            parentId: value.parentId,
            salesPersonCitizenId: (value.sales) ? value.sales.citizenId : null,
            supervisorCitizenId: (value.parent && value.parent.sales) ? value.parent.sales.citizenId : root,
            levelSequence: value.level
          });
        });

        const list = data.sort((a, b) => Number(a.levelSequence) - Number(b.levelSequence));

        this.onHandler.emit(list);
        //
        // if (transfer) {
        //   this.onTransfer.emit(list);
        // }
      });
  }

  listToTree(data, options): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        options = options || {};
        const ID_KEY = options.idKey || 'code';
        const PARENT_KEY = options.parentKey || 'parent';
        const CHILDREN_KEY = options.childrenKey || 'children';

        const PARENT_CODE_KEY = options.parentCodeKey || 'code';
        const PARENT_SALES_KEY = options.parentSalesKey || 'sales';

        const tree = [];
        const childrenOf = {};
        let item;
        let id;
        let parentId;

        for (let i = 0, length = data.length; i < length; i++) {
          item = data[i];
          id = item[ID_KEY];
          parentId = item[PARENT_KEY] || 0;
          childrenOf[id] = childrenOf[id] || [];
          item[CHILDREN_KEY] = childrenOf[id];

          if (parentId !== 0) {
            const parent = Object.assign({}, data.filter(x => x[ID_KEY] === item[PARENT_KEY])[0]);

            if (parent) {
              item.parent = {
                code: parent[PARENT_CODE_KEY],
                sales: parent[PARENT_SALES_KEY]
              };
            }

            childrenOf[parentId] = childrenOf[parentId] || [];
            childrenOf[parentId].push(item);
          } else {
            tree.push(item);
          }
        }

        return resolve(tree);
      } catch (e) {
        return reject(e);
      }
    });
  }

  onSelectTeam(parent) {
    this.team.parent = {
      code: parent.code,
      sales: parent.sales
    };

    parent.children.push(this.team);

    this.onTreeChange();
  }
}
